module.exports = __webpack_public_path__ + "img/0-lg.4da964dc.jpg";